<template>
  <div class="supervision">
    <div class="banner">
      <img src="../../assets/img/supervisionAndReporting/banner.jpg" />
      <div class="banner-text">
        <div class="container wow slideInLeft">
          <h1>{{$t("supervisionAndReporting.banner.bannerTitle")}}</h1>
          <p>{{$t("supervisionAndReporting.banner.bannerP")}}</p>
        </div>
      </div>
    </div>
    <div class="container">
      <p class="introduce">{{$t("supervisionAndReporting.introduce")}}</p>
      <div class="reporting">
        <div class="headline">
          <h1>{{$t("supervisionAndReporting.reporting1.headlineTitle")}}</h1>
          <p>{{$t("supervisionAndReporting.reporting1.headlineP")}}</p>
        </div>
        <el-row :gutter="30">
          <el-col :span="12" :xs="24">
            <img src="../../assets/img/supervisionAndReporting/form.png" />
          </el-col>
          <el-col :span="12" :xs="24">
            <div>
              <h3>{{$t("supervisionAndReporting.reporting1.title1")}}</h3>
              <div v-html="$t('supervisionAndReporting.reporting1.des1')" class="des"></div>
              <h3>{{$t("supervisionAndReporting.reporting1.title2")}}</h3>
              <div v-html="$t('supervisionAndReporting.reporting1.des2')" class="des"></div>
              <el-button  @click="onlineReporting" class="onlineBtn"><img src="../../assets/img/supervisionAndReporting/finger.png" />{{$t('supervisionAndReporting.reporting2.btn')}}</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="reporting">
        <div class="headline">
          <h1>{{$t("supervisionAndReporting.reporting2.headlineTitle")}}</h1>
          <p>{{$t("supervisionAndReporting.reporting2.headlineP")}}</p>
        </div>
        <el-row :gutter="30">
          <el-col :span="12" :xs="24">
            <div>
              <h3>{{$t("supervisionAndReporting.reporting2.title1")}}</h3>
              <div v-html="$t('supervisionAndReporting.reporting2.des1')" class="des"></div>
              <h3>{{$t("supervisionAndReporting.reporting2.title2")}}</h3>
              <div v-html="$t('supervisionAndReporting.reporting2.des2')" class="des"></div>
              <h3>{{$t("supervisionAndReporting.reporting2.title3")}}</h3>
              <h3>{{$t("supervisionAndReporting.reporting2.title4")}}</h3>
            </div>
          </el-col>
          <el-col :span="12" :xs="24">
            <img src="../../assets/img/supervisionAndReporting/form2.png" />
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog
      :title="$t('supervisionAndReporting.dialogForm.title')"
      :visible.sync="dialogForm"
      :width="isMobile()?'100%':'900px'"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="140px"
        class="demo-ruleForm"
      > 
        <el-row :gutter="30">
          <el-col :span="12" :xs="24">
            <el-form-item :label="$t('supervisionAndReporting.dialogForm.email')" prop="email">
              <el-input v-model="ruleForm.email" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item :label="$t('supervisionAndReporting.dialogForm.reporterType')" prop="reporterType">
              <el-select v-model="ruleForm.reporterType" disabled style="width:100%;">
                <el-option :label="language=='cn' ? item.dictLabel : language=='en'?item.cssClass : item.remark " :value="item.dictValue" v-for="(item,index) in reporterType" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('supervisionAndReporting.dialogForm.reporterItems')" prop="reporterItems" >
          <el-checkbox-group v-model="ruleForm.reporterItems">
            <el-checkbox :label="item.dictValue" v-for="(item,index) in reporterItems" :key="index">{{language=='cn' ? item.dictLabel : language=='en'?item.cssClass : item.remark }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-row :gutter="30">
          <el-col :span="12" :xs="24">
            <el-form-item :label="$t('supervisionAndReporting.dialogForm.reportered')" prop="reportered">
              <el-input v-model="ruleForm.reportered" :placeholder="$t('supervisionAndReporting.dialogForm.reporteredTip')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item :label="$t('supervisionAndReporting.dialogForm.deptName')" prop="deptName">
              <el-input v-model="ruleForm.deptName" :placeholder="$t('supervisionAndReporting.dialogForm.deptName')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="30">
          <el-col :span="12" :xs="24">
            <el-row :gutter="30">
              <el-col :span="18">
                <el-form-item :label="$t('supervisionAndReporting.dialogForm.reporter')" prop="reporter">
                  <el-input v-model="ruleForm.reporter" :placeholder="$t('supervisionAndReporting.dialogForm.reporterTip')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label-width="0">
                  <el-checkbox v-model="ruleForm.ifShow" :true-label="1" :false-label="0">{{$t('supervisionAndReporting.dialogForm.ifShow')}}</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item :label="$t('supervisionAndReporting.dialogForm.reporterMobile')" prop="reporterMobile">
              <el-input v-model="ruleForm.reporterMobile" :placeholder="$t('supervisionAndReporting.dialogForm.reporterMobile')" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- accept=".xlsx, .xls" -->
        <el-row :gutter="30">
          <el-col :span="12" :xs="24">
            <el-form-item :label="$t('supervisionAndReporting.dialogForm.file')"  prop="file">
              <el-upload
                ref="upLoad"
                class="upload-demo"
                :loading="importLoading"
                action="#"
                :on-change="handleUpload"
                :on-remove="handleRemove"
                :auto-upload="false"
                drag
              >
              <!-- multiple -->
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">{{$t('supervisionAndReporting.dialogForm.fileTip')}} <em>{{$t('supervisionAndReporting.dialogForm.fileBtn')}}</em></div>
                <!-- <div class="el-upload__tip text-center" slot="tip">
                  <span>仅允许导入xls、xlsx格式文件。</span>
                </div> -->
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-form-item :label="$t('supervisionAndReporting.dialogForm.remark')"  prop="remark">
          <el-input type="textarea" v-model="ruleForm.remark" :placeholder="$t('supervisionAndReporting.dialogForm.remarkTip')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">{{$t('supervisionAndReporting.dialogForm.btn')}}</el-button>
          <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {by_typename} from "../../api/news"
import { submitReporter ,uploadFile } from "../../api/talentRecruitment"
import { mapGetters } from "vuex";

export default {
  name: "SupervisionAndReporting",
  data() {
    return {
      dialogForm: false,
      ruleForm: {
        sayType :"1",       //类型：1投诉举报、2联系我们、3简历投递
        reporterType : '1',   //举报类型编号
        reporterItems : [],  //举报事项编号
        reportered : '',     //被举报人
        reporter : '',       //信息提交人姓名
        reporterMobile : '',  //联系方式
        email : 'gh_wang@gaoxincarbon.com',  //邮箱
        deptName  : '',     //所在单位及部门
        ifShow  : 0,        //是否匿名
        fileNos : [],          //上传举报材料
        remark  : '',         //问题描述
      },
      rules: {  
        reporterItems: [
          {
            type: 'array',
            required: true,
            message: this.$t('supervisionAndReporting.dialogForm.reporterItemsTip'),
            trigger: "change"
          }
        ],
        deptName: [
          { required: true, message: this.$t('supervisionAndReporting.dialogForm.deptNameTip'), trigger: "blur" },
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
        reporterMobile: [
          { required: true, message: this.$t('supervisionAndReporting.dialogForm.reporterMobileTip'), trigger: "blur" },
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
      },
      importLoading :false,
      reporterType:[],
      reporterItems:[],
      fileList:[]
    };
  },
  computed:{
    ...mapGetters(['language'])
  },
  mounted() {
    var options = { live: false };
    new this.$wow.WOW(options).init();
    
    // 举报类型
    by_typename(this.language,{dictType:'dqgx_repoter_type'}).then(res=>{
      this.reporterType= res.data;
    });
    // 举报事项
    by_typename(this.language,{dictType:'dqgx_repoter_item'}).then(res=>{
      this.reporterItems= res.data;
    });
  },
  methods: {
    onlineReporting() {
      this.dialogForm = !this.dialogForm;
    },
    submitForm(ruleForm) {
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          submitReporter(this.language,this.ruleForm).then(res =>{
            this.dialogForm=false;
            this.$refs[ruleForm].resetFields();
            this.$message.success(res.msg);
          })
        } else {
          return false;
        }
      });
    },
    // resetForm(formName) {
    //   this.$refs[formName].resetFields();
    // },
    // 文件上传
    handleUpload(file){
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        return this.$message.error($t('supervisionAndReporting.dialogForm.uploadTip')+' 50MB!');
      }
      uploadFile(this.language,file.raw).then(res => {
        const { createTime, fileName, fileNo, fileUrl, extension } = res.data
        this.fileList.push(res.data);
        this.ruleForm.fileNos.push(fileNo);
      })
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
      const index=this.fileList.findIndex(item => item.uid=== file.uid);
      this.fileList.splice(index, 1);
      this.ruleForm.fileNos.splice(index, 1);
    },
    isMobile() {
        const userAgentInfo = navigator.userAgent;
        const mobileAgents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        const mobileFlag = mobileAgents.some((mobileAgent) => {
            return userAgentInfo.indexOf(mobileAgent) > 0;
        });

        return mobileFlag;
    }

  }
};
</script>

<style scoped lang="scss">
$cblue: #0054a7;
.supervision {
  .introduce {
    width: 60%;
    margin: 0 auto;
    text-align: justify;
    margin-top: 100px;
  }
  .reporting {
    h3 {
      font-weight: bold;
      line-height: 2;
      text-align: justify;
    }
    .des {
      text-indent: 2em;
      text-align: justify;
    }
  }
  .onlineBtn{
    color:#0054a7;
    margin-left:2em;
    margin-top:20px;
    img{
      height:28px;
      margin-right:10px;
    }
  }
  ::v-deep .el-form-item__label{
      line-height: normal;
    }
    @media screen and (max-width:768px){
      .introduce {
        width: 100%;
        margin: 0 auto;
        text-align: justify;
        margin-top: 40px;
      }
      .el-upload-dragger .el-icon-upload {
        margin:0;
        line-height: normal;
      }
      ::v-deep .el-upload{
        display: block;
      }
      ::v-deep .el-upload-dragger{
        width:100%;
        height: auto;
      }
      ::v-deep .el-checkbox{
        white-space: normal;
      }
    }
}
</style>
